import React, { useEffect } from 'react';
import { InputText, InputRadio } from 'schola-components';
import { t, tString } from 'components/translation/Translation';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';
import { contactOptions } from '../utils/contactOptionsArray';
import { hearOptions } from '../utils/hearOptionsArray';
import { languageOptions } from '../utils/languageOptionsArray';
import scrollToError from 'util/scrollToError';
import './profile-form.scss';
import { QuestionCircleOutlined } from '@ant-design/icons';

const ProfileForm = ({ form, handleInput, errors }) => {
  useEffect(() => {
    scrollToError(errors);
  }, [errors]);

  return (
    <div className="profile-form layoutv3" data-testid="profileBodyForm">
      <div className="spacing-mb-32">
        <InputText
          className="w-100"
          label={t('onboarding:onboarding.firstName')}
          id="parent_first_name"
          placeholder={tString('onboarding:onboarding.firstName')}
          name="parent_first_name"
          value={form.parent_first_name}
          onChange={handleInput}
          error={!!errors.parent_first_name}
          errorMessage={errors?.parent_first_name}
        />
      </div>

      <div className="spacing-mb-32">
        <InputText
          className="w-100"
          label={t('onboarding:onboarding.lastName')}
          id="parent_last_name"
          placeholder={tString('onboarding:onboarding.lastName')}
          name="parent_last_name"
          value={form.parent_last_name}
          onChange={handleInput}
          error={!!errors.parent_last_name}
          errorMessage={errors?.parent_last_name}
        />
      </div>

      <div className="spacing-mb-32" id="contact">
        <span className="font-14 font-600 text-dark-blue-75">{t('onboarding:onboarding.contact')}</span>
        <InputRadio
          className="contact-info__radio-button"
          data={contactOptions}
          currentSelect={form.contact}
          onChange={(e) => handleInput(e)}
        />
        <p className="input_errorMessage">{errors?.contact}</p>
      </div>

      <div className="contact-info__optional spacing-mb-32">
        <InputText
          label={t('onboarding:onboarding.phone')}
          placeholder={tString('onboarding:onboarding.phone')}
          id="phone"
          name="phone"
          value={form.phone}
          onChange={handleInput}
          error={errors?.phone}
          errorMessage={errors?.phone}
          className="contact-info__optional-phone w-100"
        />
      </div>

      <div style={{ display: 'flex', gap: '7px' }}>
        <span className="font-14 font-600 text-dark-blue-75 spacing-mb-12">
          {t('onboarding:onboarding.current_residence')}
        </span>
        <div className="school-feature__question--icon">
          <span data-tip data-for="tooltip-address">
            <QuestionCircleOutlined />
          </span>
          <ReactTooltip id="tooltip-address" place="right" type="dark" border>
            <div className="school-feature__question--description">{t('onboarding:onboarding.addressTooltip')}</div>
          </ReactTooltip>
        </div>
      </div>

      <div className="spacing-mb-32">
        <InputText
          className="contact-info__optional-field w-100"
          placeholder={tString('onboarding:onboarding.current_residence')}
          id="current_residence"
          name="current_residence"
          value={form.current_residence}
          onChange={handleInput}
          error={errors?.current_residence}
          errorMessage={errors?.current_residence}
        />
      </div>

      <div className="spacing-mb-32">
        <InputText
          className="w-100"
          label={t('onboarding:onboarding.zip')}
          placeholder={tString('onboarding:onboarding.zip')}
          id="zipcode"
          name="zipcode"
          value={form.zipcode}
          onChange={handleInput}
          error={errors?.zipcode}
          errorMessage={errors?.zipcode}
        />
      </div>

      <div className="spacing-mb-32" id="language">
        <span className="font-14 font-600 text-dark-blue-75">{t('onboarding:onboarding.language')}</span>
        <InputRadio
          className="contact-info__radio-button"
          data={languageOptions}
          currentSelect={form.language}
          onChange={(e) => handleInput(e)}
        />
        <p className="input_errorMessage">{errors?.language}</p>
      </div>

      <div className="spacing-mb-32" id="how_did_you_hear">
        <span className="font-14 font-600 text-dark-blue-75">{t('onboarding:onboarding.how_did_you_hear')}</span>
        <InputRadio
          className="contact-info__radio-button"
          data={hearOptions}
          currentSelect={form.how_did_you_hear}
          onChange={(e) => handleInput(e)}
        />
        {form.how_did_you_hear == 'Other' && (
          <InputText
            className="w-100 spacing-mt-8"
            placeholder={tString('onboarding:onboarding.other_please_specify')}
            id="other_how_did_you_hear"
            name="other_how_did_you_hear"
            value={form.other_how_did_you_hear}
            onChange={handleInput}
            error={errors?.other_how_did_you_hear}
            errorMessage={errors?.other_how_did_you_hear}
          />
        )}
        <p className="input_errorMessage">{errors?.how_did_you_hear}</p>
      </div>
    </div>
  );
};

ProfileForm.propTypes = {
  form: PropTypes.object.isRequired,
  handleInput: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

export default ProfileForm;
